import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import Spinner from "components/spinner/Spinner";
import { displayNotification, generateOptionsFromData, sendAPIRequest } from "helpers";
import { useLazyGetCountryUsersQuery } from "modules/pvs_activities/redux/service/user";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionDelegateModal = ({ isShow, initModal }) => {

    const missionContext = useContext(MissionContext);
    const { t } = useTranslation();
    const [form, setForm] = useState({  mission_delegate_id: missionContext.missionDelegate });
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [setUserRes, userRes] = useLazyGetCountryUsersQuery();

    useEffect(() => {
        if (missionContext.missionData?.country_id) setUserRes({countryId: missionContext.missionData?.country_id, all: 1});
    }, [missionContext.missionData]);

    useEffect(() => {
        if (userRes.isError) {
            displayNotification("error", "Failed to load country users");
            console.log(userRes.error);
        }
    }, [userRes]);

    const handlePopupValueChange = (val) => {
        setForm({ mission_delegate_id: val });
    };

    const userOptions = useMemo(() => {
        if (userRes.isSuccess) return generateOptionsFromData(userRes.data, {
            value: "id",
            label: "name",
        });
        return [];
    }, [userRes]);

    const handleSave = async () => {
        try {
            setIsBtnLoading(true);
            const data = await sendAPIRequest(`/api/pvsa/mission-request/${missionContext.missionData.id}`, "PUT", form);
            const response = await data.json();
            if (response.success) {
                displayNotification("success", "Successfully updated mission delegate");
                setIsBtnLoading(false);
                initModal();
                missionContext.taskTrigger();
            } else {
                setIsBtnLoading(false);
                displayNotification("error", "Failed to change mission delegate");
            }
        } catch (e) {
            setIsBtnLoading(false);
            console.log(e);
            displayNotification("error", "Failed to change mission delegate");
        }
    };

    return (
        <Modal show={isShow}>
            <Modal.Header closeButton onClick={() => initModal()}>
                <Modal.Title>Assign Mission Delegate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AutoCompleteDropdown
                    showClearIcon={false}
                    error={false}
                    required={false}
                    multiple={false}
                    label={"Select Mission Delegate"}
                    hasselectall={false}
                    options={userOptions}
                    onChange={(event, value) => {
                        handlePopupValueChange(value.value);
                    }}
                    value={userOptions.find((r) => r.value == form.mission_delegate_id) ?? null}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={handleSave}>
                    {isBtnLoading ? (
                        <Spinner message="Saving..." />
                    ) : (
                        <>
                            {" "}
                            <i className="fa-sharp fa-solid fa-check"></i>
                            {t("85", "Save")}
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

MissionDelegateModal.defaultProps = {
    isShow: false,
    initModal: () => { },
};

export default MissionDelegateModal;
